"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccordionItem = void 0;
var _objectDestructuringEmpty2 = _interopRequireDefault(require("@babel/runtime/helpers/objectDestructuringEmpty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _Item = require("./Item.js");
/**
 * A list item in the Accordion component.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-accordion-accordionitem--docs) |
 * [Encore site](https://encore.spotify.net/web/components/accordion) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/AccordionItem) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?node-id=4037-6864)
 */
var AccordionItem = exports.AccordionItem = /*#__PURE__*/_react["default"].forwardRef(function AccordionItem(_ref, ref) {
  var props = (0, _extends2["default"])({}, ((0, _objectDestructuringEmpty2["default"])(_ref), _ref));
  return /*#__PURE__*/_react["default"].createElement(_Item.Item, Object.assign({
    ref: ref
  }, props, {
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.AccordionItem
  }));
});